if(document.querySelector('.switch')){
    if(document.querySelector('.careerSection__description')){
        var currentPost = document.querySelector('.switch__content--visible')
        document.querySelector('.careerSection__description').style.height = currentPost.height + 'px'
    }
    const items = document.querySelectorAll('.switch li');
    items.forEach(item => {
        item.addEventListener('click', () => {
            if (!item.classList.contains('switch__option--open')) {
                var current = document.querySelector('.switch__option--open');
                current.classList.remove('switch__option--open')
                item.classList.add('switch__option--open')
                var currentPost = document.querySelector('.switch__content--visible')
                currentPost.classList.remove('switch__content--visible')
                var id = item.getAttribute('data-switch')
                var post = document.querySelector('.switch__content[data-switch="' + id + '"]')
                post.classList.add('switch__content--visible')
                if(document.querySelector('.careerSection__description')){
                    document.querySelector('.careerSection__description').style.height = currentPost.height + 'px'
                }
            }
        })
    });
}